"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./video.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Video = function Video(_ref) {
  var title = _ref.title,
      embedLink = _ref.embedLink,
      caption = _ref.caption;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Video"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "h2"
  }, title), /*#__PURE__*/_react["default"].createElement("iframe", {
    title: title,
    src: embedLink,
    width: "560",
    height: "315",
    frameBorder: "0",
    allowFullScreen: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "caption"
  }, caption));
};

Video.propTypes = {
  title: _propTypes["default"].string,
  embedLink: _propTypes["default"].string.isRequired,
  caption: _propTypes["default"].string
};
Video.defaultProps = {
  title: null,
  caption: null
};
var _default = Video;
exports["default"] = _default;